import React from 'react';
import { 
  gasConcentrationFields, 
  additionalMonitoringFields, 
  fluidManagementFields, 
  proceduresList 
} from '../constants/options';

const ClinicalNotesSection = ({ formData, handleChange, handleProcedureChange }) => {
  return (
    <>
      <div className="flex items-center mb-6">
        <div className="w-3 h-8 bg-teal-600 rounded-full mr-4"></div>
        <h2 className="text-2xl font-bold text-teal-700">Clinical Documentation & Notes</h2>
      </div>
      <div className="border-2 border-teal-200 rounded-xl p-6 bg-gradient-to-br from-teal-50 to-white shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
            <h4 className="text-lg font-semibold mb-4 text-gray-700 flex items-center">Gas Concentrations</h4>
            <div className="space-y-3">
              {gasConcentrationFields.map(({ key, label, placeholder }) => (
                <div key={key}>
                  <label className="block text-sm font-medium mb-1 text-gray-600">{label}</label>
                  <input
                    type="text"
                    value={formData[key] || ''}
                    onChange={handleChange(key)}
                    placeholder={placeholder}
                    className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
                    aria-label={label}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
            <h4 className="text-lg font-semibold mb-4 text-gray-700 flex items-center">Additional Monitoring</h4>
            <div className="space-y-3">
              {additionalMonitoringFields.map(({ key, label, placeholder }) => (
                <div key={key}>
                  <label className="block text-sm font-medium mb-1 text-gray-600">{label}</label>
                  <input
                    type="text"
                    value={formData[key] || ''}
                    onChange={handleChange(key)}
                    placeholder={placeholder}
                    className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
                    aria-label={label}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
            <h4 className="text-lg font-semibold mb-4 text-gray-700 flex items-center">Fluid Management</h4>
            <div className="space-y-3">
              {fluidManagementFields.map(({ key, label, placeholder }) => (
                <div key={key}>
                  <label className="block text-sm font-medium mb-1 text-gray-600">{label}</label>
                  <input
                    type="text"
                    value={formData[key] || ''}
                    onChange={handleChange(key)}
                    placeholder={placeholder}
                    className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
                    aria-label={label}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-teal-200">
          <h4 className="text-lg font-semibold mb-4 text-gray-700 flex items-center">
            Additional Procedures & Complications
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {proceduresList.map(({ key, label }) => (
              <label
                key={key}
                className="flex items-center p-3 rounded-lg bg-white border border-gray-200 hover:bg-teal-50 transition-colors cursor-pointer shadow-sm"
              >
                <input
                  type="checkbox"
                  checked={formData.procedures?.[key] || false}
                  onChange={handleProcedureChange(key)}
                  className="mr-3 w-4 h-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                  aria-label={label}
                />
                <span className="text-sm font-medium">{label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-teal-200">
          <h4 className="text-lg font-semibold mb-3 text-gray-700">Clinical Notes</h4>
          <textarea
            value={formData.clinicalNotes || ''}
            onChange={handleChange("clinicalNotes")}
            placeholder="Additional clinical observations, complications, or important notes during the procedure..."
            className="w-full border-2 border-gray-300 rounded-lg px-4 py-3 h-24 text-sm focus:border-teal-500 focus:outline-none transition-colors resize-none"
            aria-label="Clinical Notes"
          />
        </div>
      </div>
    </>
  );
};

export default ClinicalNotesSection;
